import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { showCashout } from 'right-sidebar';

export default () => {
  useEffect(() => {
    showCashout();
  }, []);

  return <Redirect to="/" />;
};
